import { isSameDay } from 'date-fns'

import { userApi } from '~/redux/apis/user-api'
import { USER_API_TAGS } from '~/redux/constants/tags.const'
import { selectSreakUpdatedAt, setStreakUpdatedAt } from '~/redux/slices/dashboard'
import { storeInstance } from '~/redux/store'

export function invalidateStreakIfNeeded(): void {
  const streakUpdatedAt = selectSreakUpdatedAt(storeInstance.getState())
  const now = Date.now()
  if (shouldInvalidateStreak(streakUpdatedAt, now)) {
    storeInstance.dispatch(userApi.util.invalidateTags([USER_API_TAGS.UserStreak]))
    storeInstance.dispatch(setStreakUpdatedAt(now))
  }
}

function shouldInvalidateStreak(streakUpdatedAt: number | null, now: number): boolean {
  if (!streakUpdatedAt) return true
  const lastDate = new Date(streakUpdatedAt)

  return !isSameDay(now, lastDate)
}
